"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FavoritesDialog = require("./FavoritesDialog");
Object.keys(_FavoritesDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FavoritesDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FavoritesDialog[key];
    }
  });
});
//# sourceMappingURL=index.js.map